import { Box, styled } from "@mui/material";

export const IndicatorStyled = styled(Box)`
	width: 0.25em;
	border-radius: 1.5267em;
	height: 3.8em;
	margin-top: -1em;
	position: relative;
	z-index: 9999;
	background-color: #fff;

	&.portrait {
		width: 0.5em;
	}

	&.marker {
		background-color: transparent;

		&.portrait {
			background-color: #fff;
			margin-left: -0.2386em;
		}
	}
`;

export const LoyaltyContainer = styled("div")`
	display: flex;
	position: absolute;
	top: -2.7em;
	height: 2.7em;
	z-index: -1;

	&::before {
		content: "";
		bottom: -0.6em;
		z-index: -1;
		position: absolute;
		background-color: rgba(255, 255, 255, 0.6);
		width: 0.25em;
		height: 3em;
		border-radius: 1.5267em;
		display: block;
	}
	&.portrait {
		&::before {
			width: 0.5em;
		}
	}
	&.marker::before {
		bottom: -1.9561em;
	}

	&.marker.portrait::before {
		bottom: -0.5248em;
	}
`;

export const LoyaltyPoints = styled("span")`
	display: flex;
	align-items: center;
	gap: 0.32em;
	margin: 0.32em 0 0 1.28em;
	font-weight: bold;
	color: #fff;
	&.reverse {
		transform: translateX(-135%);
	}
	&.marker {
		margin: 2.2999em 0 0 1.2266em;

		&.portrait {
			margin: 0 0 0 1.0685em;
		}
	}
`;
